import React from 'react'
import PANCard from '../components/organism/PANCard'


const PANPage = () => {
  return (
    <>
   <PANCard/>
    </>
  )
}

export default PANPage